const prefixes = {
  courses: 'crs',
  startedCourses: 'scrs',
  testBank: 'tst',
  testAttempts: 'tat',
  events: 'evt',
  blogs: 'blg',
  additionalPages: 'adp',
  team: 'mem',
  courseApplications: 'cap',
  eventApplications: 'eap',
  courseCategories: 'cat-course',
  eventCategories: 'cat-event',
  blogCategories: 'cat-blog'
}

let lastTimestamp = 0
let sameTimestampIndex = 0

export function getEntityPrefix(type) {
  return prefixes[type] || type || 'item'
}

export function createEntityId(type) {
  const timestamp = Date.now()
  const suffix = timestamp === lastTimestamp ? `-${++sameTimestampIndex}` : ''
  lastTimestamp = timestamp
  if (!suffix) sameTimestampIndex = 0
  return `${getEntityPrefix(type)}-${timestamp}${suffix}`
}

export function createNestedId(parentId, groupKey) {
  return createEntityId(`${parentId}-${groupKey}`)
}

function dateTimestamp(value) {
  if (!value) return 0
  if (typeof value.toMillis === 'function') return value.toMillis()
  if (typeof value === 'object' && Number.isFinite(value.seconds)) return value.seconds * 1000
  if (typeof value === 'number') return value

  const timestamp = Date.parse(value)
  return Number.isNaN(timestamp) ? 0 : timestamp
}

export function entityCreationTimestamp(item) {
  const explicitTimestamp = dateTimestamp(item && (item.createdAt || item.created))
  if (explicitTimestamp) return explicitTimestamp

  const idMatch = String((item && item.id) || '').match(/-(\d{10,})(?:-\d+)?$/)
  return idMatch ? Number(idMatch[1]) : 0
}

export function sortEntitiesNewestFirst(items) {
  return [...(items || [])].sort((first, second) => {
    return entityCreationTimestamp(second) - entityCreationTimestamp(first)
  })
}
